module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isSearchMode == true && _vm.searchModeTypeahead == true) ? _c('v-select', {
    staticClass: "style-chooser",
    staticStyle: {
      "font-size": "12px!important"
    },
    attrs: {
      "clearable": false,
      "options": _vm.fieldOptions,
      "single-line": true,
      "value": _vm.fieldValue
    },
    on: {
      "input": _vm.updateValue
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n    対象はありません\n  ")])], 2) : (_vm.isSearchMode == true) ? _c('select', {
    class: {
      'form-control': true, 'select-box': true, 'limited-height-box': _vm.isSearchMode == true
    },
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue,
        "value": o
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  })], 2) : _c('div', {
    class: {
      'form-group': _vm.isSearchMode == false, 'esma_form_group': _vm.isSearchMode == false
    }
  }, [(_vm.showLabel && _vm.isSearchMode == false) ? _c('label', {
    class: {
      'col-xs-4': true, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass + ' select-box4',
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('select', {
    class: {
      'form-control': true, 'select-box': true, 'limited-height-box': _vm.isSearchMode == true
    },
    style: (_vm.filedStyle),
    attrs: {
      "disabled": this.isLoading || _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, [(_vm.disallowFirstEmptyOption == false) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue,
        "value": o
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7931e154","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/select-box4.vue
// module id = 1035
// module chunks = 0